import {Component, OnInit} from "@angular/core";
import {NumPipe} from "../shared/pipes/num.pipe";
import {AuthService} from "../auth.service";
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "../shared/services/utils.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {DateAdapter} from "@angular/material/core";

import { environment } from '../../environments/environment';
import {Subject} from "rxjs";

declare let swal:any;

@Component({
  selector: 'app-recap-hashting',
  templateUrl: './recap-hashting.component.html',
  styleUrls: ['./recap-hashting.component.css']
})
export class RecapHashtingComponent implements OnInit {

  page: number = 1;
  totalPage: number = 1;
  search: string = "";
  limit: number = 10;
  sortBy: any = ['id'];
  revert: boolean = false;
  txtQueryChanged: Subject<string> = new Subject<string>();

  errors: any = {};
  isLoading: boolean = false;

  hashtingId: number;

  hashting: any = {};

  pharmacy_campaigns: any = [];
  environment: any;

  constructor(
    private numPipe: NumPipe,
    public authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>,
    public utils: UtilsService
  ) {
    this.dateAdapter.setLocale('fr');
  }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      let id = params['id'];
      if (id) {
        this.hashtingId = id;
        this.getHashting();

        this.authService.getSession();
      }
      else {
        this.router.navigate(['..'], {relativeTo: this.route});
      }
    });
  }

  goToHashting() {
    this.router.navigate(['administration', 'hashting']);
  }


  getHashting(resetPage = false) {
    this.isLoading = true;

    if (resetPage == true)
      this.page = 1;

    var query = "";
    if (this.authService.connectedAs.admin == false)
      query += "?connectedAsId=" + this.authService.connectedAs.id;

    this.http.get(environment.API_PATH + '/hashting/recapitulatif/' + this.hashtingId + query, {withCredentials: true})
      .subscribe(
        data => {
          this.isLoading = false;
          console.log(data);
          this.hashting = data;
        },
        err => {
          this.isLoading = false;
          if (err.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (err.status === 404) {
            this.utilsService.displayNotif("Cette campagne n'existe pas", "danger");
            this.router.navigate(['../..'], {relativeTo: this.route});
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        });
  }

  getConnectionsCount(codes) {
    let count = 0;
    if (codes) {
      codes.forEach( c => {
        count += c.connections;
      });
    }

    return count;
  }

  getReductionsCount(codes) {
    let count = 0;
    if (codes) {
      codes.forEach( c => {
        c.connection_details.forEach(d => {
          if (d.value)
            count += d.value;
        });
      });
    }

    return count;
  }

  getTotalConnexions() {
    let count = 0;
    if (this.hashting.venue) {
      this.hashting.venue.forEach(v => {
        if (v.campaigns && v.campaigns.codes) {
          v.campaigns.codes.forEach(c => {
            count += c.connections;

          })
        }
      });
    }

    return count;
  }

  getTotalReductions() {
    let count = 0;
    if (this.hashting.venue) {
      this.hashting.venue.forEach(v => {
        if (v.campaigns && v.campaigns.codes) {
          v.campaigns.codes.forEach(c => {
            c.connection_details.forEach(d => {
              if (d.value)
                count += d.value;
            });
          });
        }
      });
    }

    return count;
  }

  parseStatus(status) {
    switch (status) {
      case "None":
        return "NC";
      case "Requested":
        return "Demandé";
      case "RequestAccepted":
        return "Demande accepté";
      case "WaitingForFinancialInfo":
        return "En attente d'informations financière";
      case "ReadyToPay":
        return "Prêt à être payé";
      case "Paid":
        return "Payé";

      default:
        return "NC";

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/recap-hashting/recap-hashting.component.ts